<template>
  <div>

    <!-- Personal -->
    <scroll-section name="Personal" :id="'applicant-'+index+'-capture-section-personal'"
    :show="shown">
      <!-- Swapping -->
      <loading-icon-text-button
        class="md-raised"
        :loading="spinning"
        @click="swapApplicantType"
        icon="save"
        v-if = "index > 0"
        :disabled="validated"
      >Make as Primary Applicant
      </loading-icon-text-button>

      <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>

      <md-button
        class="md-primary md-simple md-dense"
        @click="snackbar.show = false"
        >Dismiss</md-button
      >
    </md-snackbar>

    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content" />

      <!-- Contact Details -->
      <scroll-section name="Contact Details" :id="'applicant-'+index+'-capture-section-personal-contact-details'"
      :show="shown">
        <edit-applicant-contact-details v-model="applicant" :prefixLabel="prefixLabel" :index="index" />
      </scroll-section>

      <!-- Current Address -->
      <scroll-section name="Current Address" :id="'applicant-'+index+'-capture-section-addresses-current'"
      :show="shown">
        <edit-applicant-current-address
          v-model="applicant"
          :auto-duration-mandation-service="address_auto_duration_mandation_service"
          :index="index"
          :prefixLabel="prefixLabel + ' Current Address'"
        />
      </scroll-section>

      <!-- Previous Address -->
      <!-- TODO invest on why this cause the dialog in EditApplicantVedaReport disappear-->
      <!-- <scroll-section name="Previous" :id="'applicant-'+index+'-capture-section-addresses-previous-new'"
      :idname="'applicant-'+index+'-capture-section-addresses-previous-new'" :idindex="index" :show= "shown" :ishidden="toShowPrevious" v-if="toShowPrevious">
        <edit-applicant-previous-addresses v-model="applicant"
        :auto-duration-mandation-service="address_auto_duration_mandation_service"
        :prefixLabel="prefixLabel + ' Previous Address'" />
      </scroll-section> -->

      <!-- Privacy Consent -->
      <scroll-section name="Credit Report" :id="'applicant-'+index+'-capture-section-personal-privacy'" :show="shown">
        <edit-applicant-credit-report v-model="applicant" :application="application" :index="index" @application-change="$emit('application-change')" />
      </scroll-section>

      <!-- Previous Address -->
      <scroll-section name="Previous" :id="'applicant-'+index+'-capture-section-addresses-previous'" :show="shown"
      :ishidden="false">
        <edit-applicant-previous-addresses v-model="applicant"
        :auto-duration-mandation-service="address_auto_duration_mandation_service"
        :prefixLabel="prefixLabel + ' Previous Address'"/>
      </scroll-section>

    </scroll-section>


    <!-- Addresses -->
    <scroll-section name="Addresses" :id="'applicant-'+index+'-capture-section-addresses'"
    :show="shown">

      <!-- Landlord Details -->
      <transition v-bind="transitions.expand">
        <scroll-section name="Landlord" :id="'applicant-'+index+'-capture-section-addresses-landlord'" v-if="toShowLandlord"
        :show="shown">
          <edit-applicant-landlord-details v-model="applicant" :prefixLabel="prefixLabel + ' Current Landlord'" :index="index" />
        </scroll-section>
      </transition>

    </scroll-section>

    <!-- Employments -->
    <scroll-section name="Employment" :id="'applicant-'+index+'-capture-section-employment'"
    :show="shown">

      <!-- Current Employments -->
      <scroll-section name="Current" :id="'applicant-'+index+'-capture-section-employment-current'"
      :show="shown">
        <edit-applicant-current-employments v-model="applicant"
        :auto-duration-mandation-service="employment_auto_duration_mandation_service"
        :prefixLabel="prefixLabel + ' Current Employment'" />
      </scroll-section>

      <!-- Previous Employments -->
      <scroll-section name="Previous" :id="'applicant-'+index+'-capture-section-employment-previous'"
      :show="shown">
        <edit-applicant-previous-employments v-model="applicant"
        :auto-duration-mandation-service="employment_auto_duration_mandation_service"
        :prefixLabel="prefixLabel + ' Previous Employment'" />
      </scroll-section>

      <!-- Other Incomes -->
      <scroll-section name="Other Incomes" :id="'applicant-'+index+'-capture-section-employment-other-incomes'"
      :show="shown">
        <edit-applicant-other-incomes v-model="applicant" :prefixLabel="prefixLabel + ' Income'"/>
      </scroll-section>

      <!-- Spouses Details -->
      <transition v-bind="transitions.expand">
        <scroll-section name="Spouses Details" :id="'applicant-'+index+'-capture-section-employment-spouse'" v-if="toShowSpousesDetails"
        :show="shown">
          <edit-applicant-spouses-details
            v-model="applicant"
            :application="application"
            :index="index"
            :prefixLabel="prefixLabel + ' Spouses'"/>
        </scroll-section>
      </transition>

    </scroll-section>

    <!-- Document Requests -->
    <scroll-section name="Document Requests" :id="'applicant-'+index+'-capture-section-document_requests'"
    :show="shown">
      <edit-applicant-document-requests v-model="applicant" :application="application" :index="index"/>
    </scroll-section>

    <!-- Bank Statement Report -->
    <!-- <scroll-section name="Bank Statement Report" :id="'applicant-'+index+'-capture-section-bank-statement-report'"
    :show="shown">
      <edit-applicant-bank-statement-report v-model="applicant" :application="application" :index="index" @application-change="$emit('application-change')"/>
    </scroll-section> -->

    <!-- Living Expenses -->
    <scroll-section name="Living Expenses" :id="'applicant-'+index+'-capture-section-living-expenses'"
    :show="shown">
      <edit-applicant-living-expenses v-model="applicant" :prefixLabel="prefixLabel + ' Expenses'" :index="index" />
    </scroll-section>

    <!-- Assets -->
    <scroll-section name="Assets & Liabilities" :id="'applicant-'+index+'-capture-section-assets'"
    :show="shown">
      <edit-applicant-assets-and-liabilities v-model="applicant" :application="application" :prefixLabel="prefixLabel + ' Assets'" :index="index" />
    </scroll-section>

    <!-- Assets -->
    <scroll-section
        name="Capacity Analysis"
        :id="'applicant-'+index+'-capture-section-capacity'"
        :show="shown">
        <capacity-analysis :application="application"  v-model="applicant"/>
    </scroll-section>

    <!-- References -->
    <scroll-section name="References" :id="'applicant-'+index+'-capture-section-references'"
    :show="shown">
      <edit-applicant-references v-model="applicant" :prefixLabel="prefixLabel + ' References'"/>
    </scroll-section>
  </div>
</template>

<script>
import filters from '@/components/utils/filters';
import transitions from "@/components/utils/transitions";
import utils from "@/components/utils/utils";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import { isAddressRentLike, hasSpouse, hasVedaReport } from "@/components/utils/validation";
import ValidatedInputs from '@/components/ValidatedInput';
import Editors from '@/components/Editors'
import ScrollSection from "@/components/ScrollTracker/ScrollSection.vue";
import CapacityAnalysis from './CapacityAnalysis.vue';

export default {
  data(){
    return {
      snackbar: {
        show: false,
        icon: "done",
        content: "",
      },
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      spinning: false,
      transitions,
      address_auto_duration_mandation_service: new utils.AutoDurationMandationService(36),
      employment_auto_duration_mandation_service: new utils.AutoDurationMandationService(36),
    };
  },
  components: {
    LoadingIconTextButton,
    CapacityAnalysis,
    ...ValidatedInputs,
    ...Editors,
    ScrollSection,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    index: {
      type: [Number, String],
      default: 0,
    },
    shown: {
      type: Boolean,
      default: true,
    },
    quickrefresh: {
      type: Boolean,
      default: true,
    },
    application:{
      type: Object,
      required: true,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
  },
  computed: {

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get(){ return this.value },
      set(applicant){ this.$emit('input', applicant) },
    },

    toShowLandlord(){
      return isAddressRentLike(this.applicant.addresses.current);
    },
    toShowSpousesDetails(){
      return hasSpouse(this.applicant.personal_details);
    },
    toShowPrevious(){
      return hasVedaReport(this.applicant.veda_report);
    },
    validated(){
      const mailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let validated = this.applicant.contact.name.firstname.length > 1
        && this.applicant.contact.name.lastname.length > 1
        && mailFormat.test(this.applicant.contact.emails[0].email);
      return !validated;
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,

    async swapApplicantType() {
      this.spinning = true;
      this.$store.dispatch("swap_applicant_type", this.index);

      try {
            let result = await this.$store.dispatch("save_application", this.application);

            if (result) {
              this.snackbar.content = "Application saved successfully";
              this.snackbar.icon = "done";
              this.snackbar.show = true;
              this.spinning = false;
              window.location.reload(); // TODO need to changed later.
            }
          } catch (e) {
            this.error_dialog.title = "Error saving application";
            this.error_dialog.content = `Error Message: ${e.response.data}`;
            this.error_dialog.show = true;
          }
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'address_history_ownership',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
